export default "__VITE_ASSET__BGYeZUBa__"